import {Injectable, OnDestroy} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {ProjectsService} from "./projects.service";
import {Subject, BehaviorSubject, ReplaySubject, takeUntil} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {tap} from "rxjs/operators";

const getProjectdetailsURL = environment.projectSettingsURL;

@Injectable({
  providedIn: 'root'
})
export class ThemesService implements OnDestroy {
  private projectShortName = new BehaviorSubject<string | null>(null);
  private ngUnsubscribe = new Subject();
  public projectSettings = new ReplaySubject<any>(1);

  constructor(
    private activatedRoute: ActivatedRoute,
    private projectService: ProjectsService,
    private http: HttpClient
  ) {
    this.addBodyClass();
    this.getProjectDetails();
  }

  checkThemeSettings(projectShortname: string | null) {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params?.['theme']) {
        this.projectService.getThemeSettings().subscribe({
          next: successResponse => {
            successResponse.filter((projectTheme: any) => {

              if (
                projectShortname &&
                projectTheme.template &&
                projectTheme.template.toLowerCase() === projectShortname.toLowerCase() + '-' + params?.['theme'].toLowerCase()
              ) {

                this.projectService.setLogo(projectTheme.logo);
                this.projectService.setLoading(false);
                // console.log('projectTheme.gdpr_link',projectTheme.gdpr_link);
                this.projectService.setGdprLink(projectTheme.gdpr_link);

              } else {
                this.projectService.setLoading(false);
              }
            });
          }
        });
      }
    });
  }

  addBodyClass() {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params?.['theme']) {
        this.projectShortName.subscribe(
          (projectShortname) => {
            if (projectShortname && params?.['theme']) {
              const themeName = params?.['theme'];
              const body = document.body;
              body.classList.add(projectShortname.toString().toLowerCase() + '-v2-' + themeName.toLowerCase());
            }
          }
        );
      }
    });
  }

  setProjectShortName(projectShortName: string | null) {
    this.projectShortName.next(projectShortName);
  }

  getProjectShortName() {
    return this.projectShortName.asObservable();
  }

  getProjectDetails() {
    this.http.get(getProjectdetailsURL).pipe(
      tap(
        res => res
      )
    ).pipe(
      takeUntil(this.ngUnsubscribe)
    ).subscribe((x) => {
      this.projectSettings.next(x);
    });
  }

  getDetailProjectDetails() {
    return this.projectSettings.asObservable();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next(false);
    this.ngUnsubscribe.complete();
  }

}
